import { graphQlClient } from '@config/graphqlClient';
import UsersInsideAreaGraphQL from '@graphql/usersInsideArea.queries';
import {
  UserInsideArea,
  UsersInsideAreaFilter,
} from '@models/usersInsideArea.model';

interface GetUsersInsideAreaResponse {
  getUsersInsideArea: UserInsideArea[];
}

export const usersInsideAreaService = {
  async getUsersInsideArea(filter: UsersInsideAreaFilter): Promise<UserInsideArea[]> {
    const data: GetUsersInsideAreaResponse = await graphQlClient.request(
      UsersInsideAreaGraphQL.queries.getUsersInsideArea,
      { filter },
    );
    return data.getUsersInsideArea || [];
  },
};

export default usersInsideAreaService;
